import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class ReachableContactModel extends BaseModel {
  @attr("string") type;
  @attr("string") name;
  @attr("string") email;
  @attr("string") phone;
  @attr("string") title;
}
